module.exports = __webpack_public_path__ + "static/media/ic_view-more.eb0be995.svg";